export class SearchInput {
	id: number;
	searchString: string;
	searchTypeCode: string
	itemTypeId: number;
	closeStatusId: number;
    entityStatusCode: string;
    itemStatusId: number;
    assignedToId: number;
	ownedById: number;
	processStepId: number;
    tagId: number;
}